export const environment = {
  production: true
};

// const BASE_URL = 'http://23.22.202.197:3000/';
// const MYSQL_BASE_URL = 'http://23.22.202.197:5000/v1/';
// const prod_BASE_URL = 'http://23.22.202.197:4201/';
// const uptime_API_URL = 'http://23.22.202.197:5050/api/';

// const BASE_URL = 'https://punchout-daynite.dnasmarketplace.com/';
// const MYSQL_BASE_URL = 'https://api-daynite.dnasmarketplace.com/v1/';
// const prod_BASE_URL = 'https://products-daynite.dnasmarketplace.com/';
// const uptime_API_URL = 'https://api.uptimeassets.com/api/'

const BASE_URL = 'https://punchout.uptimeassets.com/'; //'http://54.152.47.182:3000/';
const MYSQL_BASE_URL = 'https://api-admin.uptimeassets.com/v1/'; //'http://54.152.47.182:5000/v1/';
const prod_BASE_URL = 'https://api-products.uptimeassets.com/';//'http://54.152.47.182:4201/';
const uptime_API_URL = 'https://api-frontend.uptimeassets.com/api/';//'http://54.152.47.182:5050/';

export const ServerPath = {
  /**
   * BASE_URLs
   */
  auth: BASE_URL + 'auth/',
  vendor: BASE_URL + 'vendor/',
  technician: BASE_URL + 'technician/',
  users: BASE_URL + 'users/',
  profile: BASE_URL + 'profile/',
  dashboard: BASE_URL + 'dashboard/',
  searchProducts: BASE_URL + 'product/',
  search: BASE_URL + 'search/',

  /**
   * MYSQL_BASE_URLs
   */
  lookupTypes: MYSQL_BASE_URL + 'lookuptypes/',
  lookup: MYSQL_BASE_URL + 'lookups/',
  configuration: MYSQL_BASE_URL + 'configurations/',
  cart: MYSQL_BASE_URL + 'cart/',
  emailTemplates: MYSQL_BASE_URL + 'emailTemplates/',
  messageCenter: MYSQL_BASE_URL + 'message/',
  deviceRegistration: MYSQL_BASE_URL + 'deviceRegistrations/',
  notification : MYSQL_BASE_URL + 'notifications/',
  rfqs: MYSQL_BASE_URL + 'rfq/',
  roleMenuMapping : MYSQL_BASE_URL + 'roleMenuMappings/',
  menus : MYSQL_BASE_URL + 'menus/',
  purchaseOrder : MYSQL_BASE_URL + 'po/',
  managePurchaseOrder : MYSQL_BASE_URL + 'po/',
  punchout: MYSQL_BASE_URL + 'punchout/',
  emailHistory:MYSQL_BASE_URL + 'emailHistories/',
  dashboardData: MYSQL_BASE_URL + 'dashboardData/',
  workorder: MYSQL_BASE_URL + 'workorders/',
  productPunchout: MYSQL_BASE_URL + 'vndrPntPnchtDtls',  
  punchoutVendorsList: MYSQL_BASE_URL + 'getpunchoutvendorslist', 
  businessLicenseeData: MYSQL_BASE_URL + 'businesslicenseecomapnay/',
  xmlParser : MYSQL_BASE_URL + 'xml/',
  uptimeCart: MYSQL_BASE_URL + 'uptimeCarts/',
  uptimeCustomer: MYSQL_BASE_URL + 'uptimeCustomers/',
  uptimeRfq: MYSQL_BASE_URL + 'uptimerfqs/',
  uptimeOrder: MYSQL_BASE_URL + 'uptimeOrders/',
  uptimeSeller: MYSQL_BASE_URL + 'uptimeSellers/', 
  uptimeManufacturer : MYSQL_BASE_URL + 'uptimeManufacturers/',
  uptimeBusinessLicensee : MYSQL_BASE_URL + 'uptimeBusinessLicensees/',
  uptimeSubscriptionEnquiry : MYSQL_BASE_URL + 'uptimeEnquiry/',
  uptimeSaleRequest : MYSQL_BASE_URL + 'uptimeSaleRequest/list',
  managePromotion : MYSQL_BASE_URL + 'uptimePromotions',
  boaPayout : MYSQL_BASE_URL + 'uptimeBOATransactions',
  uptimeNftAuctionPayout : MYSQL_BASE_URL + 'uptimeNftAuctionPayout',

  
  /**
   * prod_BASE_URLs
   */
  products: prod_BASE_URL + 'product/',
  productsBulkUpload: prod_BASE_URL + 'bulkUpload/',
  equipmentsBulkUpload: prod_BASE_URL + 'bulkUploadEquipment/',
  equipments: prod_BASE_URL + 'equipment/',
  equipmentCategory : prod_BASE_URL + 'category/',
  equipmentNFT: prod_BASE_URL + 'sold-equipment/',
  manageSubsc: prod_BASE_URL + 'subscription/',
  samproReq: prod_BASE_URL + 'sampro/',
  subscProductManage: prod_BASE_URL + 'subscription-product/',

  /**
   * Uptime frontend API URLS
   */
  uptimeCustomerCart: uptime_API_URL + 'cart/',
  rfqCartEmail : uptime_API_URL + 'user/',
  uptimeManageSaleReq: uptime_API_URL + 'sellrequest/',
  uptimeManageAuction: uptime_API_URL + 'auction/',
  manageNFTShareAuction: uptime_API_URL + 'nftShareAuction/',
  manageWallet: uptime_API_URL + 'wallets/',
  sellingPayout: uptime_API_URL + 'payout/',
  sellingTransfer: uptime_API_URL + 'transfer/',
  soldEquipment : prod_BASE_URL + 'sold-equipment/'
};

export const s3Bucket = {
  userImg: 'https://s3.us-east-1.amazonaws.com/prod-uptime-s3/users/',
  productImg: 'https://s3.us-east-1.amazonaws.com/prod-uptime-s3/products/',
}

export const AwsCredentials = {
  S3_accessKeyId : 'AKIAXZ46W45MNOQFT2WM',
  S3_secretAccessKey :'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',
  S3_region :'us-east-1',
  S3_BUCKET:'prod-uptime-s3',
}

